import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "product-card__benefits--internet",
  "data-eq-part": "product-card__benefits"
}

import Product from '@/classes/Product';
import List from '@/components/List.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductCardBenefitsInternet',
  props: {
    product: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(List, {
      type: "icon",
      icon: "fa-solid fa-check",
      items: _ctx.product.benefits
    }, null, 8, ["items"])
  ]))
}
}

})